export default "https://cdn.questicon.mathletics.com/assets/images/icon-measure-image-b5bc56e5474234c7a73eb4f5453576d4.svg";